import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { BaseSiteService, UserIdService } from '@spartacus/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, retry, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MyAccountPermissionService {
  baseSite$: Observable<string> = this.baseService.getActive();
  userCurrent$: Observable<string> = this.auth.getUserId();
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  url: string;

  currentUserPermissions$ = new BehaviorSubject(null);
  currentUserId$ = new BehaviorSubject(null);

  constructor(
    private meta: Meta,
    protected http: HttpClient,
    protected baseService: BaseSiteService,
    protected auth: UserIdService
  ) {
    this.baseSite$.pipe(take(1)).subscribe((baseSiteData) => {
      this.url = `${this.occUrl.content}${environment.prefix}${baseSiteData}`;
    });
  }

  get baseSiteId(): string {
    let baseSiteId: string;
    this.baseSite$.pipe(take(1)).subscribe((baseSiteData) => (baseSiteId = baseSiteData));
    return baseSiteId;
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  get UserId(): string {
    let UserId: string;
    this.currentUserId$.pipe(take(1)).subscribe((uid) => (UserId = uid));
    return UserId;
  }

  getMyAccountPermissionList() {
    return this.http
      .get(`${this.url}/users/${this.userCurrent}/management/storeFrontPermissions`)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  getShipToAddress(employee?: string): Observable<any> {
    let currentUSerUid = employee !== undefined ? employee : this.UserId;
    return this.http
      .get(
        `${this.url}/users/${this.userCurrent}/addresses/shipToAddresses?withDefaultAddress=true&userId=${currentUSerUid}&fields=FULL`
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  // Error handling
  errorHandl(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
